<template>
  <v-dialog v-model="dialog" max-width="620" persistent>
    <template v-slot:activator="{ on }">
      <v-btn
        color="white"
        class="color-a"
        text
        v-on="on"
        style="width: 100%;
          margin-bottom: 8px;"
      >
        <div class="icon-button-container">
          <div class="icon-button-text">
            Skapa ny organisation
          </div>
          <div class="icon-button-icon">
            <v-icon right style="color: rgba(255,255,255,1);">
              mdi-plus
            </v-icon>
          </div>
        </div>
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="color-a">
        Lägg till ny organisation
      </v-card-title>
      <v-card-text>
        <v-form v-model="valid" ref="form">
          <h3>Organisationstyp</h3>
          (Viktigt: organisationstyp kan inte ändras efter att organisationen
          skapats)
          <v-select
            prepend-icon="mdi-form-select"
            v-model="form.organizationType"
            :items="[
              'bostadsrättsförening',
              'förening utan viktade röster',
              'förening med viktade röster',
              'aktiebolag',
              'samfällighetsförening'
            ]"
          ></v-select>
          <h3>Uppgifter</h3>
          <v-text-field
            v-model="form.name"
            label="Namn"
            prepend-icon="mdi-form-textbox"
            :rules="nameRules"
            required
          ></v-text-field>
          <v-text-field
            v-model="form.email"
            label="E-postadress"
            prepend-icon="mdi-at"
            :rules="emailRules"
            required
          ></v-text-field>
          <p
            style=" margin-top: 10px; border: 1px solid #ccc; padding: 11px; border-radius: 4px; "
          >
            Innan ni lägger in medlemmar i Percap måste ni enligt GDPR godkänna
            vårt personbiträdesavtal och ange vem hos er som är ansvarig.
            <a
              href="https://firebasestorage.googleapis.com/v0/b/percap-7af8f.appspot.com/o/assets%2Fpersonal-data-assistant-agreement.html?alt=media&token=4dc020aa-4d47-46fc-abf3-9f698c025f4f"
              target="_blank"
              >Tryck här för att läsa avtalet</a
            >. Ni godkänner avtalet genom att ange personuppgiftsansvarig nedan.
          </p>

          <v-text-field
            v-model="form.nameGdpr"
            label="Namn på personuppgiftsansvarig"
            prepend-icon="mdi-form-textbox"
            :rules="nameRules"
            required
          ></v-text-field>

          <v-text-field
            v-model="form.emailGdpr"
            label="E-postaddress till personuppgiftsansvarig"
            prepend-icon="mdi-form-textbox"
            :rules="emailRules"
            required
          ></v-text-field>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="close">Avbryt</v-btn>
        <v-btn text color="primary" type="submit" @click="create"
          >Lägg till
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
const form = {
  name: "",
  organizationType: "bostadsrättsförening",
  ssn: ""
};

const voteWeightModel = function(organizationType) {
  switch (organizationType) {
    case "förening med viktade röster":
    case "aktiebolag":
      return "weighted";
    case "samfällighetsförening":
      return "samfallighet";
    default:
      return "unweighted";
  }
};

export default {
  data() {
    return {
      valid: false,
      dialog: false,
      form: { ...form },
      emailRules: [v => !!v || "Email är obligatoriskt"],
      nameRules: [v => !!v || "Namn är obligatoriskt"]
    };
  },
  methods: {
    close() {
      this.form = { ...form };
      this.dialog = false;
    },
    async create() {
      if (this.$refs.form.validate()) {
        const success = await this.$store.dispatch(
          "organizations/createOrganization",
          {
            ...this.form,
            voteWeightModel: voteWeightModel(this.form.organizationType)
          }
        );
        if (success) {
          this.close();
        }
      }
    }
  }
};
</script>

<style></style>
